export default {
    'game_selector_Dashboard': 'Dashboard',
    'game_selector_tab1': 'Game',
    'game_selector_tab2': 'Studio&Company',
    'game_selector_input_placeholder': 'Navigation search',
    'game_selector_recent_title': 'Recent Viewed',
    'game_selector_follow_title': 'My Following',
    'game_selector_game_list_title': 'Game List',
    'game_selector_no_authority_title': 'No Authority',
    'game_selector_access': 'Get Access',
    'game_selector_no_data': 'No result found',
    'game_selector_no_Search_metrics': 'Search pages or metrics',
    'game_selector_title_game_related': 'My Related',
    'game_selector_title_game_all': 'All Games',
    'game_selector_title_game_new': 'New Games',

    'game_selector_following_bubble': 'Following',
    'game_selector_follow_bubble': 'Follow',
    'game_selector_edit_btn': 'Edit',
    'game_selector_edit_title': 'Edit My Following Games',
    'game_selector_edit_all_game': 'All Games',
    'game_selector_edit_select_game': 'Selected',
    'game_selector_all_tab': 'All',
    'game_selector_access_tab': 'With Access',
    'game_selector_no_access_tab': 'No Access',
    'game_selector_request_access': 'Request Access',
    'game_selector_request_access_bubble': 'Has all version permissions',

    'game_selector_search_text': 'Search',

    'game_selector_confirm': 'Confirm',
    'game_selector_cancel': 'Cancel',
    'game_selector_game_table_header': 'Games',
    'game_selector_game_no_autority': 'No Authority',
    'game_selector_game_get_access': 'Get Access',
    'game_selector_game_no_access' : 'Dashboard的游戏权限申请请联系DataBrain-Studio业务对接人员或Sallyxue@tencent.com',

    'game_selector_recent_game_no_data': '暂无最近查看的游戏，请到 {link1} 或 {link2} 查找游戏',
    'game_selector_follow_game_no_data': '暂无关注的游戏，请到 {link1} 或 {link2} 关注游戏',
}
